export default __webpack_public_path__ + "static/media/shahid.632eaa93.jpeg";